<template>
    <div class="modal" :class="modalType.modalType" @mousedown="closeOnClick" @keyup.esc="close">
        <div class="modal__container" @mousedown.stop @click.stop>
            <i class="mdi mdi-close modal__close" @click="close"></i>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: ['type'],

    computed: {
        modalType() {
            let modalType = '';

            switch (this.type) {
                case 'large':
                    modalType = 'modal--large';
                    break;
                case 'small':
                    modalType = 'modal--small';
                    break;
            }

            return {
                modalType: modalType,
            };
        },
    },
})
export default class Modal extends Vue {
    name = 'modal';

    close(e) {
        this.$emit('close');
    }

    closeOnClick(e) {
        if (e.clientX < window.innerWidth - 15) {
            // Only propagate if not attempting to click on the scroll bar
            this.close(e);
        }
    }

    beforeMount() {
        document.body.classList.add('modal__open');

        document.onkeyup = e => {
            if (e.keyCode === 27 || e.which === 27) {
                this.close();
            }
        };
    }

    destroyed() {
        document.body.classList.remove('modal__open');
    }
}

Vue.component('modal', Modal);
</script>
